<template><div></div></template>

<script>
export default {
  beforeMount() {
    this.$router.push("/performance");
  },
};
</script>
